import React, { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
//
import Box from "@mui/material/Box";
import useLocaleRoute from "../../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../../hooks/useModulePublic";
import { StoreContext } from "../../../../../../store/StoreProvider";
import Selection from "../../../../../../common/components/input/Selection";
//
import Act from "../../../../../../store/actions";
import urls from "../../../../../../api/project/ApiUrls";
import { selectOpts } from "./option";

const AccordionDetailChildren = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale, group } = user;
  const { adjust } = sna;
  const { legendShowNodDataGroup } = adjust || {};
  // local state
  const [localOptions, setLocalOptions] = useState(selectOpts);
  const [inputVal, setInputVal] = useState(legendShowNodDataGroup.change);
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  const handleInputChange = (e) => {
    const { value } = e.target;
    setInputVal(value);
    dispatch({
      type: Act.SNA_ADJUST_LEGEND_SHOW_NO_DATA_GROUP_CHANGE,
      payload: value,
    });
  };

  return (
    <Box>
      <Selection
        options={localOptions}
        size="normal"
        darkMode
        fullWidth
        inputProps={{
          value: inputVal,
          onChange: handleInputChange,
          // defaultValue: "",
        }}
        MenuProps={{}}
      />
    </Box>
  );
};

export default AccordionDetailChildren;
